<template lang="pug">
div
	listado-tareas
</template>

<script>
import TareasProduccion from './components/listado-fases/listado.vue'
export default {
	name: 'produccion',
	components: {
		'listado-tareas': TareasProduccion
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/App.vue